import Address from "components/Parts/Address";
import CartHeader from "components/Parts/CartHeader";
import KioskSurface from "components/Parts/Kiosk/KioskSurface";
import SignupAddOns from "components/Parts/SignupAddOns";

const Parts =  {
	Address : Address,
	CartHeader : CartHeader,
	KioskSurface : KioskSurface,
	SignupAddOns : SignupAddOns,
};

export default Parts;
